var React = require('react');

function Refresh (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.3 12.7C32.41 9.8 28.42 8 24 8 15.16 8 8.02 15.16 8.02 24S15.16 40 24 40c7.45 0 13.69-5.1 15.46-12H35.3c-1.65 4.66-6.07 8-11.3 8-6.63 0-12-5.37-12-12s5.37-12 12-12c3.31 0 6.28 1.38 8.45 3.55L26 22h14V8l-4.7 4.7z"}));
}

Refresh.displayName = "Refresh";

Refresh.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Refresh;

Refresh.default = Refresh;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/refresh.svg